import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    isRequired: '* Verplicht veld',
  },
  en: {},
};
